var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.56 5.8h11.2l-.6 8.42a3 3 0 0 1-3 2.78h-4a3 3 0 0 1-3-2.78l-.6-8.42ZM11.16 9l-.4 4.8M7.16 9l.4 4.8M3.16 2.6c-.66 0-1.2.54-1.2 1.2v.8c0 .66.54 1.2 1.2 1.2h12c.66 0 1.2-.54 1.2-1.2v-.8c0-.66-.54-1.2-1.2-1.2l-3.2-.4c0-.66-.54-1.2-1.2-1.2h-3.2c-.66 0-1.2.54-1.2 1.2l-3.2.4Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBin;